import sdl from '@jds/react-generated-sdl/JDSDropdownMenuInternal';
import type { JDSDropdownMenuInternalProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSDropdownMenuInternalProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'single-select',
    searchTrigger = false,
    showCTAButtons = true,
    labelTextWrap = false,
    open = false,
    menuWidthConfig = 'max-content',
    position = 'bottom_start',
    menuFullScreen = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      kind,
      searchTrigger,
      showCTAButtons,
      labelTextWrap,
      open,
      menuWidthConfig,
      position,
      menuFullScreen,
      ...rest
    },
    'JDSDropdownMenuInternal',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const DropdownMenuInternal = withLogic(
  Component
) as React.FC<JDSDropdownMenuInternalProps> & { slotName?: string };

DropdownMenuInternal.displayName = 'DropdownMenuInternal';
DropdownMenuInternal.slotName = 'jds_dropdown_menu_internal';

export { DropdownMenuInternal, type JDSDropdownMenuInternalProps };
